module.exports = __webpack_public_path__ + "static/michal-pobuda-1d7d18f65d29bf1ad4a2b2aecfb6f3b0.jpg";